module.exports = __webpack_public_path__ + "static/img/sub03.bde6e92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/sub03.png
// module id = yZRg
// module chunks = 1